export const BRAND = {
  name: "ENRICH VASTU",
  consultant: "Komel Valliea",
  logo: "/logo.png",
  favicon: "/favicon.png",
  komel: "/profile.png",
  komelCutout: "/profile.png",
  phone: "+971 569310971",
  phoneRaw: "971569310971",
  whatsapp: "971569310971",
  email: "vallieakomel@gmail.com",
  address: "Dubai, United Arab Emirates",
};

export const IMAGES = {
  heroSkyline: "https://images.unsplash.com/photo-1580674684081-7617fbf3d745?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxkdWJhaSUyMGZ1dHVyaXN0aWMlMjBza3lsaW5lJTIwbHV4dXJ5fGVufDB8fHx8MTc4NDAzMjA1MHww&ixlib=rb-4.1.0&q=85",
  water: "https://images.pexels.com/photos/20187277/pexels-photo-20187277.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  mystic: "https://images.pexels.com/photos/7222056/pexels-photo-7222056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  skyline2: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1600&q=80",
  energy: "https://images.unsplash.com/photo-1518005020951-eccb494ad742?auto=format&fit=crop&w=1400&q=80",
  compass: "https://images.unsplash.com/photo-1508615039623-a25605d2b022?auto=format&fit=crop&w=1400&q=80",
  desert: "https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?auto=format&fit=crop&w=1600&q=80",
};

export const SERVICES = [
  {
    key: "scientific-vastu",
    title: "Scientific Vastu",
    tagline: "Energy-mapped spaces, zero demolition",
    desc: "Precision realignment of your home, office and industrial spaces using measurable directional energy science.",
    items: ["Residential Vastu", "Commercial Vastu", "Office Vastu", "Industrial Vastu", "Factory Vastu", "Land Analysis", "Villa Consultation", "Apartment Consultation", "Townhouse Consultation", "High-rise Buildings", "Plot Analysis"],
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=80",
  },
  {
    key: "astrology",
    title: "Astrology",
    tagline: "Cosmic timing for life decisions",
    desc: "Vedic and Western astrology guidance for career, marriage, business and auspicious timing.",
    items: ["Personal Horoscope", "Career Guidance", "Marriage Compatibility", "Business Astrology", "Health Guidance", "Muhurat Consultation"],
    image: "https://images.pexels.com/photos/7222056/pexels-photo-7222056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "numerology",
    title: "Numerology",
    tagline: "The vibration of your numbers",
    desc: "Decode names, dates and numbers to align your identity with success and prosperity.",
    items: ["Name Correction", "Name Numerology", "Business Name Analysis", "Mobile Number Analysis", "Vehicle Number Analysis", "Lucky Numbers", "Name Calculator", "Destiny Number Reading"],
    image: "https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?auto=format&fit=crop&w=1200&q=80",
  },
  {
    key: "energy-scanning",
    title: "Energy Scanning",
    tagline: "See the invisible, balance the field",
    desc: "Advanced aura and chakra scanning to detect and neutralise negative energies in people and spaces.",
    items: ["Aura Scanning", "Seven Chakras Analysis", "Black Magic Detection", "Negative Energy Detection", "Energy Balancing", "Space Energy Analysis"],
    image: "https://images.unsplash.com/photo-1518005020951-eccb494ad742?auto=format&fit=crop&w=1200&q=80",
  },
];

export const WHY_CHOOSE = [
  { title: "Scientific, Not Superstitious", desc: "Every recommendation is backed by measurable energy principles and logic." },
  { title: "No Demolition Required", desc: "Corrections through precise remedies, colours and placement — never costly rebuilds." },
  { title: "Dubai & Global Experience", desc: "Trusted by residential, commercial and industrial clients across the UAE and beyond." },
  { title: "Complete Energy Ecosystem", desc: "Vastu, astrology, numerology and energy scanning under one premium roof." },
];

export const FAQS = [
  { q: "Do I need to break walls or renovate for Vastu?", a: "No. Our consultation focuses on demolition-free solutions that work with your existing layout." },
  { q: "Is demolition-free Vastu effective?", a: "Some layout issues can be improved with adjustments, while others may be reduced rather than fully resolved. We’ll tell you clearly what to expect." },
  { q: "Can I use Vastu in a rented flat in Dubai?", a: "Yes. Our recommendations are designed to work with your existing layout and don’t require structural changes, so they can be suitable for a rented flat." },
  { q: "Does Vastu work for flats and apartments?", a: "Yes. Apartments have their own energy signature. We correct entrance energy, bedroom axes and the North-East zone precisely, ideal for Dubai high-rise living." },
  { q: "Can Vastu be applied to villas and independent houses?", a: "Villas benefit greatly as they have all directions available. We analyse plot shape, slope, Brahmasthan and every room's energy zone." },
  { q: "Is Scientific Vastu useful for high-rise buildings?", a: "Yes. We provide floor-by-floor energy zoning that developers integrate into architectural drawings for premium positioning." },
  { q: "What is the importance of the North and North-East directions?", a: "The North-East (Ishaan) is the source of positive cosmic and solar energy. Keeping it clean and open invites clarity, prosperity and growth." },
  { q: "Can Vastu improve business growth?", a: "Definitely. Correct placement of leadership cabins, finance zones and entrances directly influences decisions, retention and cash flow." },
  { q: "How does Energy Scanning work?", a: "Using advanced techniques we measure the aura and energy field of a person or space to detect blockages and negative influences, then balance them." },
  { q: "What is Chakra Analysis?", a: "It maps the seven energy centres of the body to identify imbalances affecting health, emotions and wellbeing." },
  { q: "How is Numerology different from Astrology?", a: "Numerology decodes the vibration of numbers in your name and birth date; astrology maps celestial influence at birth. They complement each other." },
  { q: "How long does a consultation take?", a: "A focused consultation typically takes 60–90 minutes, with detailed reports delivered afterwards depending on the scope." },
];

export const ZODIAC = [
  { key: "aries", name: "Aries", dates: "Mar 21 – Apr 19", symbol: "♈" },
  { key: "taurus", name: "Taurus", dates: "Apr 20 – May 20", symbol: "♉" },
  { key: "gemini", name: "Gemini", dates: "May 21 – Jun 20", symbol: "♊" },
  { key: "cancer", name: "Cancer", dates: "Jun 21 – Jul 22", symbol: "♋" },
  { key: "leo", name: "Leo", dates: "Jul 23 – Aug 22", symbol: "♌" },
  { key: "virgo", name: "Virgo", dates: "Aug 23 – Sep 22", symbol: "♍" },
  { key: "libra", name: "Libra", dates: "Sep 23 – Oct 22", symbol: "♎" },
  { key: "scorpio", name: "Scorpio", dates: "Oct 23 – Nov 21", symbol: "♏" },
  { key: "sagittarius", name: "Sagittarius", dates: "Nov 22 – Dec 21", symbol: "♐" },
  { key: "capricorn", name: "Capricorn", dates: "Dec 22 – Jan 19", symbol: "♑" },
  { key: "aquarius", name: "Aquarius", dates: "Jan 20 – Feb 18", symbol: "♒" },
  { key: "pisces", name: "Pisces", dates: "Feb 19 – Mar 20", symbol: "♓" },
];

export const BLOG_CATEGORIES = ["All", "Scientific Vastu", "Astrology", "Numerology", "Energy Healing", "Business Vastu", "Home Vastu", "Industrial Vastu", "Success Stories", "Case Studies", "Lifestyle"];

export const PROJECT_CATEGORIES = ["All", "Residential", "Commercial", "Industrial", "Land"];
